
import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

export interface qnsbnStack {
  customerFeedbackAttachment: {}
}

@Injectable({
  providedIn: 'root'
})
export class QnSbnDataService {
  public template: boolean = false;

  storageForQnsbn: qnsbnStack = {
    customerFeedbackAttachment: {}
  };

  constructor() {
  const savedData = localStorage.getItem(this.storageKey);
  if (savedData) {
    this.storageForQnsbn = JSON.parse(savedData);
    this.mappingqnsbnDataSource.next(this.storageForQnsbn);
  }
}

  private storageKey = 'customerFeedbackAttachmentStorage';

  // Observable string sources
  private mappingqnsbnDataSource = new BehaviorSubject<object>({});

  // Observable string streams
  public mappingData$ = this.mappingqnsbnDataSource.asObservable();

  // Service message commands
  public getMappedQnsbnData(d: any, source, notificationId: string): void {
    switch (source) {
      case 'customerFeedbackAttachment':
        if (!this.storageForQnsbn.customerFeedbackAttachment) {
          this.storageForQnsbn.customerFeedbackAttachment = {};
        }
        if (!this.storageForQnsbn.customerFeedbackAttachment[notificationId]) {
          this.storageForQnsbn.customerFeedbackAttachment[notificationId] = [];
        }
      

      this.storageForQnsbn.customerFeedbackAttachment[notificationId].push(d);
      localStorage.setItem(this.storageKey, JSON.stringify(this.storageForQnsbn));
      this.mappingqnsbnDataSource.next(this.storageForQnsbn);
      return;
      default:
      return;
    }

  }
  public resetAll() {
    this.storageForQnsbn = {
      customerFeedbackAttachment:[]
    };
    this.mappingqnsbnDataSource.next({});
  }
  //Check {} object is Empty.
  public isEmpty(obj) {
    return !(() => {
      for (const i in obj) {
        return true;
      }
      return false;
    })();
  }

  public saveNcloseData(data) {
    let arrayForNotificationDocAttachments = []
    if (data.CustomerFeedbackAttachment && data.CustomerFeedbackAttachment.length > 0) {
      const attachmentData = data.CustomerFeedbackAttachment.flat();
      arrayForNotificationDocAttachments = attachmentData.map((rec) => {
        let sendInConfigAPIFormat = {
          "FileName": rec['name'],
          "FileSize": rec['size'],
          "NotificationDoc": true
        }
        return sendInConfigAPIFormat;
      })
    }
     let requestPayloadData = {
      "NotificationId": data.NotificationId || "",
      "Type": data.NotificationType || "",
      "CustomerId": data.CustomerId || "",
      "CustomerContactEmail": data.CustomerContactEmail || "",
      "ContactNotificationId": data.ContactNotificationId || "",
      "NotificationAttachments": arrayForNotificationDocAttachments || ""
    }
    return requestPayloadData;
  }

  public fileUploadData(data) {
    if(!this.isEmpty(data)){
      let fileData = [];
      if (data.CustomerFeedbackAttachment && data.CustomerFeedbackAttachment.length > 0) {
        fileData = data.CustomerFeedbackAttachment;
      }
      return fileData;
    }else{
      return [];
    }
  }
}
